// This file is ideally used for injecting data which will persist for the whole application
// This can also be used to wrap a common layout component.

import React from 'react';
import Head from 'next/head';
import App from 'next/app';
import { observer } from 'mobx-react';
import { LocaleProvider } from '../components/Generic/LocaleProvider';
import Layout from '../components/Brand/Layout';
import { contentType, contentfulConstant } from '../constants/global';
import { defaultLangKey } from '../constants/languages';
import getInitialData from '../utils/helpers/initialDataHelper';
import '../assets/css/tailwind.css';

/*
This component wraps all other page components
Therefore, this is a good place to use your Layout component
Just wrap the Layout component over the <Component /> component.
Use getInitialProps as instructed to get CSR in static export mode
*/
class MyApp extends App {
  constructor() {
    super();
    this.state = {
      routerEventAttached: false,
      showSpinner: false,
    };
  }

  static async getInitialProps({ Component, ctx }) {
    let pageProps = {};

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }
    // We will call the Layout Query Here!
    let layoutData = await getInitialData(
      contentfulConstant,
      contentType.layout,
      ctx.query.locale || defaultLangKey,
      { slug: 'index' }
    );
    layoutData = {
      ...layoutData.data,
      locale: ctx.query.locale || defaultLangKey,
    };
    return {
      pageProps,
      layoutData,
      locale: ctx.query.locale || defaultLangKey,
    };
  }

  componentDidMount = () => {
    const { routerEventAttached } = this.state;
    if (typeof window !== 'undefined' && !routerEventAttached) {
      require('../utils/routerEvents')();
      this.setState({
        routerEventAttached: true,
      });
    }
  };

  render() {
    const { Component, pageProps, layoutData, locale } = this.props;
    return (
      <>
        <LocaleProvider locale={locale}>
          <Layout layoutData={layoutData}>
            <Component {...pageProps} />
          </Layout>
        </LocaleProvider>
      </>
    );
  }
}

export default observer(MyApp);
